export const DEFfAULT_FETCHER_STATUS = {
  loading: false,
  error: null,
};

export const DEFAULT_KEY = "default";

export const homeSubPages = [
  "/",
  "/home/metrology",
  "/home/rules",
  "/home/map",
];

export const totalDistance = 7450;

export const waterLevelSensorInterval = 1000 * 20 * 5;
export const weatherSensorInterval = 1000 * 60 * 5;
